<template>
  <div class="hc-empty" role="status">
    <el-empty :image-size="imageSize" :description="emptyText">
      <template v-if="$slots.default" #default>
        <slot />
      </template>
    </el-empty>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { t } from '@/locale/index.js'

const props = defineProps({
  description: { type: String, default: '' },
  imageSize: { type: Number, default: 120 },
})

const emptyText = computed(() => props.description || t('empty'))
</script>

<style scoped>
.hc-empty {
  padding: 24px 0;
}
</style>
